import Iban from 'iban';

export const validateRequired = v => !!v || 'This field is required';

export const validateEmail = v => {
  // eslint-disable-next-line
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(v).toLowerCase()) || 'Email address is invalid';
};

export const validatePassword = v => {
  const re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  return re.test(String(v)) || 'Min length 8 symbols, 1 uppercase, 1 lowercase, 1 digit';
};

export const validatePhone = v => {
  // eslint-disable-next-line
  const re = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
  return re.test(String(v)) || 'Phone number is invalid';
};

export const validateIban = v => !v || Iban.isValid(v) ? true : 'IBAN is invalid';
